// src/main.jsx
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
// Las fuentes, desde NSL y no desde Google. Una sola vez y aquí, que es
// por donde pasa todo: repartidas por doce hojas, una se queda sin quitar.
import './fuentes.css'
import './App.css' 
import { BrowserRouter } from 'react-router-dom';
// ── EL SERVICE WORKER SE REGISTRA, NO SE IMPORTA ───────────────────────────
//  Aqui ponia `import 'virtual:pwa-register'` a secas, y eso NO registra nada.
//  Ese modulo EXPORTA una funcion `registerSW`; importarlo sin llamarla deja el
//  registro sin hacer, y como el export no se usa, el empaquetador se lleva el
//  modulo entero por delante. Medido en el build del 30-09-2026: en los 22
//  ficheros de `dist/assets` no habia ni una sola llamada a
//  `serviceWorker.register`.
//
//  O sea que NSL era instalable —el manifiesto y los iconos si estaban— pero
//  no tenia service worker activo: ni cache sin conexion, ni control de
//  actualizaciones, ni forma de recibir un aviso con la app cerrada. Salio al
//  montar los avisos al telefono, que es lo primero que lo NECESITA; lo demas
//  se degradaba en silencio y por eso llevaba meses asi.
//
//  `immediate: true` para que se registre al arrancar y no al primer cambio de
//  pagina: quien abre la app y entra directo al panel tiene que encontrarlo ya.
import { registerSW } from 'virtual:pwa-register'
registerSW({ immediate: true })
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { escucharPrimerGesto } from './audio/fx';
import { capturaRef } from './utils/afiliado.js';

// 🔪 BYPASS GLOBAL EXTIRPADO: Ahora Vite y su Proxy se encargarán 
// de mandar el tráfico a localhost:8002 en desarrollo.

// Los navegadores bloquean el audio automatico: un AudioContext creado antes
// del primer toque nace suspendido y silencia la sesion ENTERA sin avisar. Esto
// espera al primer gesto real y se desengancha solo.
escucharPrimerGesto();

// El codigo de afiliado que trae el enlace de un profesor. Se lee AQUI —en el
// arranque— y no en la pantalla de registro, porque el enlace apunta a la
// portada o a precios, no al formulario: leerlo solo alli perderia el codigo de
// todo el que hiciera una parada por el camino, que son casi todos.
capturaRef();

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);